// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Input.less';

/**
 * `Input` component.
 */
const Input = ({ size, className, baseClassName, innerRef, ...props }) => {
    const useSizeModifier = ['sm', 'md', 'lg', 'xl', 'fill'].indexOf(size) !== -1;
    return (
        <input
            ref={innerRef}
            className={classNames(
                baseClassName,
                {
                    [`${baseClassName}--size-${size}`]: useSizeModifier,
                },
                className,
            )}
            size={useSizeModifier ? null : size}
            {...props}
        />
    );
};

Input.propTypes = {
    /**
     * The HTML input type.
     */
    type: PropTypes.string,
    /**
     * Size of the input
     */
    size: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'fill']),
    ]),
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    innerRef: PropTypes.func,
};

Input.defaultProps = {
    type: 'text',
    size: 'md',
    className: undefined,
    baseClassName: `${CLS_PREFIX}input`,
    innerRef: null,
};

export default Input;



// WEBPACK FOOTER //
// ./components/Input/Input.js